import { render, staticRenderFns } from "./CulturaManifestoModal.vue?vue&type=template&id=47d19796&scoped=true"
import script from "./CulturaManifestoModal.vue?vue&type=script&lang=js"
export * from "./CulturaManifestoModal.vue?vue&type=script&lang=js"
import style0 from "./CulturaManifestoModal.vue?vue&type=style&index=0&id=47d19796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d19796",
  null
  
)

export default component.exports